export default {
    add: {
        visible: 0
    }
}